export default __webpack_public_path__ + "static/media/profile-icon.b4c6e8ba.svg";